import { render } from "./AnalyticsPieChart2.vue?vue&type=template&id=601045f6&scoped=true"
import script from "./AnalyticsPieChart2.vue?vue&type=script&lang=js"
export * from "./AnalyticsPieChart2.vue?vue&type=script&lang=js"

import "./AnalyticsPieChart2.vue?vue&type=style&index=0&id=601045f6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601045f6"]])

export default __exports__